const Testimonials = function() {
    function Testimonials() {
        this.selector = {
            container: document.querySelectorAll(".testimonial-bgimage-render"),
            reviews: document.querySelectorAll(".testimonial-review-render"),
            name: document.querySelectorAll(".testimonial-name-render"),
            title: document.querySelectorAll(".testimonial-title")
        }
        this.load()
    }
    Testimonials.prototype.load = function() {
        var _ = this;
        let loaded = false;
        window.addEventListener('scroll', function() {
                if(_.selector.container.length > 0 && window.scrollY > 10 && !loaded) {
                    _.selector.container.forEach(el => {
                            el.style.setProperty("background-image", `url(${el.dataset.bgImage})`);                       
                    })
                    _.selector.reviews.forEach(el => {
                        el.innerHTML = el.dataset.content;                       
                    })
                    _.selector.name.forEach(el => {
                        el.innerHTML = el.dataset.content;                       
                    })
                    _.selector.title.forEach(el => {
                        el.innerHTML = el.dataset.content;                       
                    })
                    loaded = true;
                }
        })
    }
    Testimonials = new Testimonials;
}
Testimonials();